import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateEventTypeDocument } from './update.generated';

export const useUpdateEventType = (options: ApiOptions<typeof UpdateEventTypeDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateEventTypeDocument, {
    ...useNotifications(UpdateEventTypeDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.event_types.update_success'),
    }),

    ...options,
  });
};
